import styled from 'styled-components';

const Ellipsis = styled.div`
    overflow: hidden;
    text-overflow: ellipsis;
`;

export default Ellipsis;
